module.exports = __webpack_public_path__ + "img/austria-pregnancy-childbirth-and-the-puerperium-female.da289fdf.png";